/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AddressType {
    HOME = 'Home',
    BUSINESS = 'Business',
    POSTAL = 'Postal',
    LOCATION = 'Location',
}
